// extracted by mini-css-extract-plugin
export default {"dropzone":"Dropzone_dropzone__in7F8","label":"Dropzone_label__1D0gk","default":"Dropzone_default__fLeKI"};